/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - European Union 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [home-space.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 06.10.18 15:48
 */

import React from 'react';
import {useLocation} from "react-router-dom";
import {useIsMobile, useLanguage} from "../components/configuration/configuration";
import LandingPage from "../components/landingpage/landing-page";

const LandingPageSpace = () => {
    const location = useLocation();
    const isMobile = useIsMobile();
    const Lang = useLanguage();

    return <div className='row'>
        <div className='col-sm-12'>
            <div className='landing-page-space-container'>
                <LandingPage/>
            </div>
        </div>
    </div>
}

export default LandingPageSpace;